module.exports = __webpack_public_path__ + "img/Delivery-Conditions.a3c6f5f6.jpg";